import { isMerchant } from '@/env'
import Vue from 'vue'
import * as mPms from '@klook/merchant-permission'
import * as aPms from '@klook/admin-permission'
function getPmsModule() {
  let pmsModule
  pmsModule = isMerchant ? mPms : aPms
  let { checkPermission } = pmsModule
  return {
    checkPermission
  }
}
export const checkPermission = getPmsModule().checkPermission

const merchantAuth = {
  actList: 'experience/act/merchant/list_page', //商户活动和套餐列表页
  pkgManage: 'experience/act/activity_manage', //商户套餐列表页 归档和取消归档
  delete: 'experience/act/activity_manage', //商户活动删除、套餐删除
  view: 'experience/act/activity_view', //商户活动查看
  edit: 'experience/act/activity_edit', //商户活动编辑
  actSubmit: 'experience/act/merchant/submit', //商户活动提交审核
  actWithdraw: 'experience/act/merchant/submit', //商户活动撤销提交
  pkgSubmit: 'experience/act/merchant/submit', //商户套餐提交审核
  pkgWithdraw: 'experience/act/merchant/submit', //商户套餐撤销提交
  editInventory: 'experience/act/inventory_edit', //商户修改库存
  superPriceEdit: 'experience/act/activity/price_edit', // 商户活动或套餐被 BD approved 后，需要有 superPriceEdit 才能修改
  // 只有高级权限才能暂停超过90天，可最多 365天
  superSuspendEdit: 'experience/act/activity/super_suspend_master',
  actFreeTextEdit: 'experience/act/freetext_edit',

  // 字数输入长度限制
  wordCountLimit: 'experience/act/word_count_limit_infinity',
  actPoiToolEdit: 'experience/act/poi_tool_edit',

  // 商户入驻临时编辑权限
  draftMerchantActCreate: 'experience/act/draft_merchant_act_create',
  // spa booking list
  exportSPABookingListExcel: 'platform/manage_booking/bookings_list/export_excel',
  spuCreated: 'experience/act/spu_created',
  coverPhotoCheckSkip: 'experience/act/coverphoto_check_skip'
}
const adminAuth = {
  // aid revamp start
  unitTypeListEdit: 'experience/act/unit_type_list_edit',
  variantListEdit: 'experience/act/variant_list_edit',
  spuCreated: 'experience/act/spu_created',
  spuDepartureDescEdit: 'experience/act/departure_desc_edit',
  spuCustomUnitTypeName: 'experience/act/custom_unit_type_name',
  viewInventoryTypeInventoryOption: 'experience/act/policy/inventory_type/option_inventory', // inventory 选项可见
  // aid revamp end
  // poi page start
  poiView: 'experience/poi_page/view',
  poiEdit: 'experience/poi_page/edit',
  // poi page end
  actList: 'experience/act/merchant/list_page', //admin审核活动和套餐列表
  view: 'experience/act/activity_view', //admin审核活动查看
  edit: 'experience/act/activity_edit', //admin审核活动编辑
  actApprove: 'experience/act/merchant/review', //admin approve活动
  actReject: 'experience/act/merchant/review', //admin reject活动
  pkgApprove: 'experience/act/merchant/review', //admin approve套餐
  pkgReject: 'experience/act/merchant/review', //admin reject套餐

  contentApiView: 'experience/act/contentApi/view',
  contentApiManagement: 'experience/act/contentApi/management',

  sspFixed: 'experience/act/price/stable_special_selling_price', //固定价格权限
  actEventLogEntry: 'act/activity_list_page',
  readSubcategory: 'experience/act/activity_page_tpl_config_view', // 读权限（活动页配置管理）
  writeSubcategory: 'experience/act/activity_page_tpl_config_operate', // 写权限（活动页配置管理）
  // 套餐附加信息-用户信息-联系信息编辑权限
  packageContactInfo: 'package_contact_info_senior_manager',
  superPriceEdit: 'experience/act/activity/price_edit', // 商户活动或套餐被 BD approved 后，需要有 superPriceEdit 才能修改
  // 套餐发布限制，ab test 查看、编辑权限
  packageLimitABTest: 'experience/act/package/publish_limit_ABTest',
  // 只有高级权限才能暂停超过90天，可最多 365天
  superSuspendEdit: 'experience/act/activity/super_suspend_master',
  // 重定向
  redirectionView: 'experience/act/redirection/view',
  redirectionEdit: 'experience/act/redirection/edit',
  redirectionBulkUpload: 'experience/act/redirection/bulk_upload',
  redirectionMigrateReviews: 'experience/act/redirection/migrate_reviews',
  redirectionABTest: 'experience/act/redirection/abtest',
  actFreeTextEdit: 'experience/act/freetext_edit',
  // 是否允许售卖价小于成本价（目前前端只在 combo 中用到）
  actSellingLessThanCost: 'act/activity_list_page/package_list_page/selling_less_than_cost',

  // 字数输入长度限制
  wordCountLimit: 'experience/act/word_count_limit_infinity',
  coverPhotoCheckSkip: 'experience/act/coverphoto_check_skip'
}

const authMap = isMerchant ? merchantAuth : adminAuth

// 默认使用脚手架权限校验方法
export const checkAuth = function (value) {
  // return true //测试代码
  if (!checkPermission) return
  // let result = checkPermission(value)
  // console.log(`auth -> ${value}`, result);
  return checkPermission(authMap[value])
}

export const initAuthDirective = function () {
  Vue.directive('auth', {
    bind: function (el, binding, vnode) {
      let value = binding.value
      if (!checkAuth(value)) {
        el.style.display = 'none'
      }
    }
  })
}

export const setDisabledLoop = function (componentName, params) {
  this.$children.forEach((child) => {
    var name = child.$options.name
    if (name === componentName) {
      _.merge(child, params)
    } else {
      setDisabledLoop.apply(child, [componentName].concat([params]))
    }
  })
}

export const setMutationObserver = function (el, callback) {
  // 选择需要观察变动的节点
  const targetNode = document.querySelector(el)
  if (!targetNode) return
  // 观察器的配置（需要观察什么变动）
  const config = { attributes: true, childList: true, subtree: true }
  // 创建一个观察器实例并传入回调函数
  const observer = new MutationObserver(callback)
  // 以上述配置开始观察目标节点
  observer.observe(targetNode, config)
}
